<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 15:05:32
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-09-13 13:37:45
-->
<template>
  <div class="page-list">
    <!-- 实时存塘量 -->
    <div class="page-search-content" ref="searchBox">
      <div class="page-big-box">
        <div class="page-search-item">
          <label>公司&nbsp;:</label>
          <el-select v-model="param.params.orgId" placeholder="请选择公司">
            <el-option label="全部公司" value=""></el-option>
            <el-option :key="item.id" v-for="item in GongSiList" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>品种&nbsp;:</label>
          <el-select v-model="param.params.breedId" placeholder="请选择品种">
            <el-option label="全部品种" value=""></el-option>
            <el-option :key="item.breedId" v-for="item in breedList" :label="item.breedName"
              :value="item.breedId"></el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>造次&nbsp;:</label>
          <el-select v-model="periodId" multiple collapse-tags placeholder="请选择造次" @change="selectPeriod"
            @remove-tag="removeTag">
            <el-option el-option label="全选" value="全选" @click.native="selectAll"></el-option>
            <el-option :key="item.id" v-for="item in PiCiList" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="page-search-btn">
        <div class="search-btn" @click="pageSearch">查询</div>
        <div class="reset-btn" @click="reSet">重置</div>
        <div class="search-close-btn">
          <div @click="PageSearchClose" v-if="PageDisplay">
            <span>收起</span><i class="iconfont icon-a-List-Expand"></i>
          </div>
          <div @click="PageSearchOn" v-else>
            <span>展开</span><i class="iconfont icon-List-Collapse"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="page-list-content">
      <div class="page-list-title">
        <div><i class="title-icon"></i>批次生产指标完成情况-养成</div>
        <div>单位 : {{ tableTitle }}</div>
        <div></div>
        <div>
          <el-dropdown style="margin-right: 30px;" @command="setFixedColumn">
            <span class="el-dropdown-link">
              冻结列<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="y">冻结至"{{
                fixedColumn.label
              }}"列</el-dropdown-item>
              <el-dropdown-item command="n">取消冻结</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span @click="doExport">
            <i class="title-export-btn iconfont icon-a-List-Export"></i>导出报表
          </span>
        </div>
      </div>
      <el-table :data="tableData" :max-height="tableHeight" border style="width: 100%" :span-method="arraySpanMethod"
        :header-cell-style="hiddenHeader" @header-click="handleClick">
        <el-table-column :fixed="fixedColumnList[0].fixed" :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''"
          prop="unitName" label="项目"></el-table-column>
        <el-table-column :fixed="fixedColumnList[0].fixed" :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''"
          prop="num"></el-table-column>
        <el-table-column :label="item.value" :key="index" v-for="(item, index) in categoryArr">
          <el-table-column prop="actual" label="实际">
            <template slot-scope="scope">
              {{ filterMethods(scope.row, item.key, "Actual") }}
            </template>
          </el-table-column>
          <el-table-column prop="plan" label="计划">
            <template slot-scope="scope">
              {{ filterMethods(scope.row, item.key, "Plan") }}
            </template>
          </el-table-column>
          <el-table-column prop="difference" label="差异">
            <template slot-scope="scope">
              {{ filterMethods(scope.row, item.key, "Difference") }}
            </template>
          </el-table-column>
          <el-table-column prop="completionRatio" label="完成比例">
            <template slot-scope="scope">
              {{ filterMethods(scope.row, item.key, "CompletionRatio") }}
            </template></el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  initPageList,
  getAllJiGou,
  getBreedList,
  getAllPiCi,
} from "./yc-quota-services";
import Page from "@/utils/methods/page";
export default {
  name: "yc",
  data() {
    return {
      pickerOptions: {
        // 超出当前年份或月份不可选
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        },
      },
      tableTitle: "",
      tableDate: "",
      tableKey: new Date() + "",
      tableHeight: 0, // 表格高度
      fixedColumn: {},
      fixedColumnList: [
        {
          prop: "unitName",
          fixed: false,
          selected: false
        },
      ],
      param: {
        currPage: 1, //第几页
        pageSize: 10, //每页条数
        // orderBy: "desc",//排序
        // orderByName: "org_name",//排序字段
        params: {
          rootOrgId: localStorage.getItem("rootId"), //顶级机构id（公司）
          orgId: "", //机构id（公司）
          breedTypeId: "", //养殖造次id
          periodId: [], //育苗批次id
          seedlingDataId: [], //养殖品类
          breedId: "", //养殖品种id
          type: "Y", //时间查询类型 Y年 M月
          startDate: null, //开始时间 月
          year: null, //年
          breedTypeClass: "fish", //分页查询类型 egg育苗 fish养成
        },
      },
      date: null, //月份区间双向绑定数据
      dateSelectNum: 1,
      PageDisplay: true,
      value: "",
      tableData: [],
      categoryArr: [],
      spanArr: [],
      GongSiList: [],
      breedList: [],
      PiCiList: [],
      periodId: [],
    };
  },
  computed: {},
  created() {
    this.tableHeight = window.innerHeight - 400;
    this.getBreedList(); // 获取品种下拉
  },
  mounted() {
    this.initPage(this.param);
    this.getAllSearchSelect();
    //合并表头推入宏任务栈
    setTimeout(() => {
      this.setColSpan();
    });
    Page.pagesTableFixed();
  },
  methods: {
    // 获取所有下拉选择项
    getAllSearchSelect() {
      let rootId = localStorage.getItem("rootId");
      Promise.all([getAllJiGou(rootId), getAllPiCi(rootId)])
        .then((result) => {
          const [JiGouData, PiCiData] = result;
          this.GongSiList = JiGouData.data;
          this.PiCiList = PiCiData.data;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-07-05 09:43:48
     * @description: 获取养殖品种下拉列表
     */
    getBreedList() {
      getBreedList(this.param.params.rootOrgId)
        .then((res) => {
          if (res.code == "0000") {
            this.breedList = res.data;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    // 根据品类key-value筛选出对应的数据
    filterMethods(data, name, type) {
      let key = name + type;
      return data[key];
    },
    // 合并单位多余表头
    setColSpan: function () {
      var x =
        document.getElementsByClassName("el-table__header")[0].rows[0].cells;
      x[0].colSpan = 2;
      x[1].style.display = "none";
    },
    doExport() {
      this.$confirm(`导出表格为excel文件，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then(async () => {
          const param = {
            rootOrgId: this.param.params.rootOrgId,
            orgId: this.param.params.orgId,
            periodId: this.param.params.periodId,
            seedlingDataId: this.param.params.seedlingDataId,
            breedTypeClass: "fish",
            year: this.param.params.year,
            startDate: this.param.params.startDate,
            type: this.param.params.type,
            breedId: this.param.params.breedId,
            fileName: "养成-指标概览报表",
          };
          const flag = await Page.exportDatas(
            "/mdtIndicatorsOrg/exportMdtIndicatorsOrgList",
            param
          );
        })
        .catch(() => { });
    },
    reSet() {
      this.param = {
        currPage: 1, //第几页
        pageSize: 10, //每页条数
        // orderBy: "desc",//排序
        // orderByName: "org_name",//排序字段
        params: {
          rootOrgId: localStorage.getItem("rootId"), //顶级机构id（公司）
          orgId: "", //机构id（公司）
          breedTypeId: "", //养殖造次id
          periodId: [], //育苗批次id
          seedlingDataId: [], //养殖品类
          breedId: "", //养殖品种id
          type: "Y", //时间查询类型 Y年 M月
          startDate: null, //开始时间 月
          year: null, //年
          breedTypeClass: "fish", //分页查询类型 egg育苗 fish养成
        },
      };
      this.periodId = [];
      this.initPage(this.param);
    },
    selectAll() {
      if (this.periodId.length < this.PiCiList.length) {
        this.periodId = [];
        this.PiCiList.map((item) => {
          this.periodId.push(item.id);
        });
        this.periodId.unshift("全选");
      } else {
        // 取消全选
        this.periodId = [];
      }
      if (this.periodId.length > 0) {
        if (this.periodId[0] == "全选") {
          this.param.params.periodId = ["total"];
        } else {
          this.param.params.periodId = this.periodId;
        }
      }
    },
    removeTag(val) {
      if (val === "全选") {
        this.periodId = [];
        this.param.params.periodId = [];
      }
    },
    selectPeriod(val) {
      if (!val.includes("全选") && val.length === this.PiCiList.length) {
        this.periodId.unshift("全选");
      } else if (
        val.includes("全选") &&
        val.length - 1 < this.PiCiList.length
      ) {
        this.periodId = this.periodId.filter((item) => {
          return item !== "全选";
        });
      }
      if (this.periodId.length > 0) {
        if (this.periodId[0] == "全选") {
          this.param.params.periodId = ["total"];
        } else {
          this.param.params.periodId = this.periodId;
        }
      }
    },
    // 查询按钮
    pageSearch() {
      this.initPage(this.param);
    },
    PageSearchClose() {
      Page.PageSearchClose(this);
    },
    PageSearchOn() {
      Page.PageSearchOn(this);
    },
    initPage(data) {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      initPageList(data).then((res) => {
        this.tableTitle = Page.orgIdFilter(data.params.orgId, this.GongSiList);
        if (data.params.type === "Y") {
          this.tableDate = data.params.year;
        } else {
          this.tableDate = Page.costMonthFilter(data.params.startDate);
        }
        this.tableData = res.data.tableData;
        this.categoryArr = res.data.categoryArr;
        if (res.data.tableData) {
          this.getSpanArr(this.tableData);
        }
        setTimeout(() => {
          loading.close();
          this.setColSpan();
        }, 0);
      });
    },
    // data是列表数据 准备好要被合并的列表数据
    getSpanArr(data) {
      this.spanArr = [];
      this.spanCodeArr = [];
      this.spanProxyArr = [];
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          // 如果是第一条记录（即索引是0的时候），向数组中加入１
          this.spanArr.push(1);
          this.spanCodeArr.push(1);
          this.spanProxyArr.push(1);
          this.pos = 0;
          this.codePos = 0;
          this.proxyPos = 0;
        } else {
          // 相同机构号
          if (data[i].unitName === data[i - 1].unitName) {
            // 如果proxy_id 相等就累加，并且push 0
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            // 不相等push 1,并且可修改下标指向
            this.spanArr.push(1);
            this.pos = i;
          }
          // 相同机构名称
          if (data[i].unitName === data[i - 1].unitName) {
            // 如果proxy_name 相等就累加，并且push 0
            this.spanCodeArr[this.codePos] += 1;
            this.spanCodeArr.push(0);
          } else {
            // 不相等push 1
            this.spanCodeArr.push(1);
            this.codePos = i;
          }
          // 相同机构归属
          if (data[i].unitName === data[i - 1].unitName) {
            // 如果proxy 相等就累加，并且push 0
            this.spanProxyArr[this.proxyPos] += 1;
            this.spanProxyArr.push(0);
          } else {
            // 不相等push 1
            this.spanProxyArr.push(1);
            this.proxyPos = i;
          }
        }
      }
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    hiddenHeader({ row, column, rowIndex, columnIndex }) {
      //合并表头推入宏任务栈
      this.$nextTick(() => {
        this.setColSpan();
      });
    },

    // 选中列
    handleClick(column, event) {
      this.fixedColumnList.forEach((item, i) => {
        if (JSON.stringify(this.fixedColumnList).includes(column.property)) {
          if (item.prop === column.property) {
            item.selected = !item.selected;
            if (item.selected) {
              this.fixedColumn = column;
              this.fixedColumn.idx = i;
            } else {
              this.fixedColumn = {};
            }
          } else {
            item.selected = false;
          }
        }
      });
    },

    // 设置冻结列
    setFixedColumn(command) {
      if (command === 'y') {
        if (JSON.stringify(this.fixedColumn) === "{}") {
          this.$message('请选择列');
          return;
        }
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.fixedColumnList.forEach((item, i) => {
          if (i <= this.fixedColumn.idx) {
            item.fixed = true;
          }
        })
        this.$message('已冻结至"' + this.fixedColumn.label + '"列');
        this.fixedColumn = {};
      } else if (command === 'n') {
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.$message('已取消冻结');
      }
    }
  },
  // 数据监听
  watch: {
    date: function (newVal, oldVal) {
      if (newVal) {
        const [date1, date2] = newVal;
        const startMonth = Page.getCurrentMonth(date1);
        const endMonth = Page.getCurrentMonth(date2);
        this.param.params.startDate = startMonth;
        this.param.params.endDate = endMonth;
      }
    },
    "param.params.type": function (newVal, oldVal) {
      if (newVal === "Y") {
        this.param.params.startDate = null;
        this.param.params.endDate = null;
        this.date = null;
        this.param.params.year = Page.getCurrentYear();
        this.initPage(this.param);
        return;
      }
      this.param.params.year = null;
      const Timer = new Date();
      this.date = [Timer, Timer]; //给到当前年月-显示在日期区间选择框内
      this.param.params.startDate = Page.getCurrentMonth();
      this.param.params.endDate = Page.getCurrentMonth();
      this.initPage(this.param);
    },
  },
};
</script>

<style lang="less" scoped></style>